import StatusStore from './StatusStore';
import UserStore from './UserStore';
import AddressStore from './AddressStore';
import ClassificationStore from './ClassificationStore';
import SearchSortStore from './SearchSortStore';
export class RootStore {
    public status: StatusStore;
    public user: UserStore;
    public address: AddressStore;
    public classification: ClassificationStore;
    public searchsort: SearchSortStore;

    constructor() {
        this.status = new StatusStore();
        this.status.root = this;
        this.user = new UserStore();
        this.user.root = this;
        this.address = new AddressStore();
        this.classification = new ClassificationStore();
        this.searchsort = new SearchSortStore();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/RootStore.ts